
var tableLess = {};
import genaration from '../../utils/classname';
export var tableClass = genaration(tableLess, 'table');